import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Autocomplete,
} from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMagLandings } from "../UseMagLandings";
import LandingGroupList from "./LandingGroupList";
import AddLandingG from "./AddLandingG";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditGroupLanding(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const {
    GetArticleGroups,
    getItemsByGroupID,
    validateGroup,
    UpdateLandingGroup,
  } = UseMagLandings();
  const [groupDetails, setGroupDetails] = useState([]);
  const groupType = [
    { id: 1, title: "جدیدترین" },
    { id: 2, title: "محبوب ترین" },
    { id: 3, title: "پربازدید ترین" },
  ];
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    groupID: undefined,
    title: undefined,
    type: undefined,
  });

  const [articleGroups, setArticleGroups] = useState();

  useEffect(() => {
    setProgress(true);
    GetArticleGroups((Articles) => {
      setArticleGroups(Articles.groups);
    });
  }, []);

  useEffect(() => {
    if (location.state.model) {
      setState({
        id: location.state.model.id,
        rowIndex: location.state.model.rowIndex,
        groupID: location.state.model.groupID,
        title: location.state.model.title,
        type: location.state.model.type,
      });
    }
  }, [location.state.model]);

  useEffect(() => {
    if (location.state) {
      getItemsByGroupID(
        location.state.model.landingID,
        location.state.model.id,
        (callback) => {
          setGroupDetails(callback);
        }
      );
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/magmanagment/LandingsManage",
        title: "مدیریت محتوا",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: location.state.parentUrl && location.state.parentUrl,
          },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/magmanagment/LandingsManage",
            LandingID: location.state.LandingID && location.state.LandingID,
            componentFaTitle:
              location.state.componentFaTitle &&
              location.state.componentFaTitle,
          },
          {
            name: "ویرایش گروه",
            url: "/magmanagment/LandingsManage/EditGroup",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان گروه"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            {articleGroups && (
              <Autocomplete
                size="small"
                value={state.groupID ? state.groupID : ""}
                onChange={(event, newValue) => {
                  setState({ ...state, groupID: newValue });
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return articleGroups?.find((m) => m.id == option)?.faName;
                  }
                  return "";
                }}
                options={articleGroups ? articleGroups.map((m) => m.id) : []}
                renderInput={(params) => (
                  <TextField
                    error={errorState.groupID}
                    variant="outlined"
                    {...params}
                    label="گروه مقاله"
                  />
                )}
              />
            )}
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <Autocomplete
              size="small"
              value={state.type ? state.type : ""}
              onChange={(event, newValue) => {
                setState({ ...state, type: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return groupType.find((m) => m.id == option).title;
                }
                return "";
              }}
              fullWidth
              options={groupType.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="نوع" />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              onClick={() => {
                if (validateGroup(state, setErrorState) == 200) {
                  if (state.groupID && !state.type) {
                    enqueueSnackbar("لطفا نوع را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (state.type && !state.groupID) {
                    enqueueSnackbar("لطفا گروه مقاله را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  UpdateLandingGroup(state, (callback) => {
                    getItemsByGroupID(
                      groupDetails.landingID,
                      groupDetails.id,
                      (callback) => {
                        setGroupDetails(callback);
                      }
                    );
                  });
                }
              }}
              color="secondary"
              sx={{ mr: 1, width: "80px" }}
              variant="contained"
            >
              ثبت
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            مقالات
          </Typography>
          <LandingGroupList
            rows={groupDetails && groupDetails.items ? groupDetails.items : []}
            groupDetails={groupDetails && groupDetails}
            landingInfo={location.state.model && location.state.model}
            allGroups={location.state.allGroups && location.state.allGroups}
            groupId={location.state.model.id}
            LandingID={location.state.LandingID}
            callback={(LandingID, groupId) => {
              getItemsByGroupID(LandingID, groupId, (callback) => {
                setGroupDetails(callback);
              });
            }}
          />
        </Box>
        <Box>
          <AddLandingG
            groupDetails={groupDetails && groupDetails}
            allGroups={location.state.allGroups}
            groupId={location.state.model.id}
            LandingID={location.state.LandingID}
            callback={(LandingID, groupId) => {
              getItemsByGroupID(LandingID, groupId, (callback) => {
                setGroupDetails(callback);
              });
            }}
            landingInfo={location.state.model && location.state.model}
          />
        </Box>
      </Box>
    </Detail>
  );
}
